(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["magnolica-newsletter"] && !Shopify.designMode) return;
  try {
    (function() {
    var form = document.querySelector('#magnolica-newsletter [data-mn-form]');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button');
      if (!input || !input.value.trim()) return;
      e.preventDefault();
      btn.disabled = true;
      btn.textContent = '…';
      var fd = new FormData(form);
      fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function(){
          form.style.display = 'none';
          var success = document.querySelector('#magnolica-newsletter [data-mn-success]');
          if (success) success.hidden = false;
        })
        .catch(function(){
          form.style.display = 'none';
          var success = document.querySelector('#magnolica-newsletter [data-mn-success]');
          if (success) success.hidden = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
